import { useMemo } from 'react';

import type { MutableRefObject, Ref, RefCallback } from 'react';

function setRef<T>(ref: Ref<T> | undefined, value: null | T): void {
  if (typeof ref === 'function') {
    ref(value);
    return;
  }

  if (ref) {
    (ref as MutableRefObject<null | T>).current = value;
  }
}

/**
 * Merges multiple React refs into a single callback ref.
 * Useful when a component needs to forward its ref while also keeping a local ref.
 */
function useForkRefs<Instance>(...refs: Array<Ref<Instance> | undefined>): null | RefCallback<Instance> {
  return useMemo(() => {
    if (refs.every((ref) => ref == null)) {
      return null;
    }

    return (instance: Instance | null) => {
      for (const ref of refs) setRef(ref, instance);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, refs);
}

export default useForkRefs;
